import "./SharedListing.css";
import React, { Fragment } from "react";

import PropertiesContent from "../PropertiesContent/PropertiesContent";
import CommonLoader from "../scripts/CommonLoader";

import InfiniteScroll from "react-infinite-scroll-component";

import { useSharedProperties } from "../scripts/SharedProperties";
import NoDataFound from "../../../components/Common/NoDataFound/NoDataFound";

const SharedListing = ({
  Type,
  FiltersParams,
  areFiltersSetToDefault,
  handleOpenModal,
  handleOpenSharedPartiesModal,
}) => {
  const [Properties, fetchProperties, hasMore] = useSharedProperties(
    Type,
    FiltersParams,
    areFiltersSetToDefault
  );

  return (
    <>
      <InfiniteScroll
        dataLength={Properties.length}
        next={fetchProperties}
        hasMore={hasMore}
        loader={<CommonLoader />}
        scrollThreshold={1}
        style={{ overflow: "inherit" }}
      >
        <div className="row">
          {Properties &&
            Properties.map((item, index) => (
              <PropertyCard
                key={item.id}
                tab={"shared"}
                type={Type}
                property={item}
                handleOpenModal={handleOpenModal}
                sharedParties={["Mazhar Jan", "Adil"]}
                handleOpenSharedPartiesModal={handleOpenSharedPartiesModal}
              />
            ))}
        </div>
      </InfiniteScroll>
      {!hasMore && Properties?.length === 0 ? (
        <Fragment>
          <div className="properties-custom-nothing-container">
            <NoDataFound />
          </div>
        </Fragment>
      ) : (
        ""
      )}
    </>
  );
};

function PropertyCard({
  type,
  tab,
  property,
  handleOpenModal,
  sharedParties,
  handleOpenSharedPartiesModal,
}) {
  return (
    <PropertiesContent
      type={type}
      tab={tab}
      property={property}
      key={0}
      CurrencySettings={{
        country: "Pakistan",
        currency: "PKR",
        currencyFormat: "numeral",
      }}
      handleOpenModal={handleOpenModal}
      sharedParties={sharedParties}
      handleOpenSharedPartiesModal={handleOpenSharedPartiesModal}
    />
  );
}

export default SharedListing;
